module.exports = __webpack_public_path__ + "img/winerack42.52a703dd.jpg";